import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDataPipe'
})
export class FormatDataPipe implements PipeTransform {
  transform(data: string | Date): string | null {
    
    if (!data) {
      return null;
    }
    
    if (data instanceof Date)  {
      return FormatDataPipe.formatDataParaString(data);
    }  
    if (typeof data === 'string') {
      return FormatDataPipe.formatStringParaString(data);         
    }
  
  }

  static formatStringParaString: Function = (data: string) => {
    data = data + "";
    if (data.length == 8) {
      return data.substring(6) + "/" + data.substring(4, 6) + "/" + data.substring(0, 4);
    }
    return data;
  }

  static formatDataParaString: Function = (data: Date) => {
    let dia = data.getDate().toString().padStart(2, '0');
    let mes = (data.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
    let ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

}


